import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { notification } from 'antd';

// services
import * as NewYearService from '../../../../services/bb-api/new-year';

export const TotalNumbers: React.FC = () => {
  const [totalUserCount, setTotalUserCount] = useState<number | null>(null);
  const [totalUserCount24h, setTotalUserCount24h] = useState<number | null>(null);
  const [totalPostCount, setTotalPostCount] = useState<number | null>(null);
  const [totalPostCount24h, setTotalPostCount24h] = useState<number | null>(null);
  const [totalMessageCount, setTotalMessageCount] = useState<number | null>(null);
  const [totalMessageCount24h, setTotalMessageCount24h] = useState<number | null>(null);
  const [totalConversationCount, setTotalConversationCount] = useState<number | null>(null);
  const [totalConversationCount24h, setTotalConversationCount24h] = useState<number | null>(null);

	const getData = useCallback(() => {
		try {
			NewYearService.totalUserCount().then(setTotalUserCount);
			NewYearService.totalUserCount24h().then(setTotalUserCount24h);
			NewYearService.totalPostCount().then(setTotalPostCount);
			NewYearService.totalPostCount24h().then(setTotalPostCount24h);
			NewYearService.totalMessageCount().then(setTotalMessageCount);
			NewYearService.totalMessageCount24h().then(setTotalMessageCount24h);
			NewYearService.totalConversationCount().then(setTotalConversationCount);
			NewYearService.totalConversationCount24h().then(setTotalConversationCount24h);
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
	}, [])

	useEffect(() => {
		getData();
		const intervalTime = 60 * 1000 // 1 min
		const intervalId = setInterval(getData, intervalTime)
		return () => clearInterval(intervalId)
	}, [getData]);

	return (
		<StyledContainer className='total-container'>
			<div className='num-container'>
				<h1>{totalUserCount?.toLocaleString() ?? 0}</h1>
        <p className='label'>Tilmeldte</p>
        <h1>{totalUserCount24h?.toLocaleString() ?? 0}</h1>
			</div>

			<div className='num-container'>
				<h1>{totalPostCount?.toLocaleString() ?? 0}</h1>
        <p className='label'>Bobler</p>
        <h1>{totalPostCount24h?.toLocaleString() ?? 0}</h1>
			</div>

			<div className='num-container'>
				<h1>{totalMessageCount?.toLocaleString() ?? 0}</h1>
        <p className='label'>Beskeder</p>
        <h1>{totalMessageCount24h?.toLocaleString() ?? 0}</h1>
			</div>

			<div className='num-container'>
				<h1>{totalConversationCount?.toLocaleString() ?? 0}</h1>
        <p className='label'>Samtaler</p>
        <h1>{totalConversationCount24h?.toLocaleString() ?? 0}</h1>
			</div>
		</StyledContainer>
	);
};

const StyledContainer = styled.div`
	display: flex;
	gap: 24px;
	align-items: center;
	justify-content: center;
	justify-items: center;
	color: #9ca3af;

	h1 {
		font-size: 84px;
		font-weight: 700;
		line-height: 1em;
    color: #ffffff;
		margin: 0;
	}

	p {
		margin: 0;
	}

	.label {
		font-size: 32px;
		margin: 0;
	}

	.num-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: rgba(31, 41, 55, 1);
		backdrop-filter: blur(10px);
		width: 400px;
		height: 250px;
		padding: 12px 24px;
		border-radius: 12px;
		/* box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px; */
	}
`;
